import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isTransparent = transparent && !scrolled;

  return (
    <nav
      className={`w-full fixed top-0 left-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 flex-shrink-0"
            aria-label="51吃瓜大赛首页"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-fire-line text-background-50 text-lg"></i>
            </div>
            <span
              className={`font-heading text-xl font-bold whitespace-nowrap ${
                isTransparent ? 'text-white' : 'text-foreground-950'
              }`}
            >
              51吃瓜大赛
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? isTransparent
                    ? 'text-white font-bold'
                    : 'text-primary-600 font-bold'
                  : isTransparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/wanghong-tafang"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.includes('/category/')
                  ? isTransparent
                    ? 'text-white font-bold'
                    : 'text-primary-600 font-bold'
                  : isTransparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/category/meiri-dasai"
              className={`relative text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isTransparent ? 'text-white/80 hover:text-white' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              <span className="flex items-center gap-1">
                <i className="ri-fire-line text-accent-500 text-base"></i>
                每日大赛
              </span>
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? isTransparent
                    ? 'text-white font-bold'
                    : 'text-primary-600 font-bold'
                  : isTransparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              isTransparent ? 'text-white' : 'text-foreground-950'
            }`}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/wanghong-tafang"
              className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname.includes('/category/')
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/category/meiri-dasai"
              className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 flex items-center gap-2"
            >
              <i className="ri-fire-line text-accent-500"></i>
              每日大赛
            </Link>
            <Link
              to="/about"
              className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/about'
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}